import { Panel } from "components/Panel/Panel";
import { CONTACT_EMAIL, DISCORD_LINK, X_LINK } from "links";
import { SingleColumnPage } from "pages/PageTemplates";
import { InfoH3, InfoHeaderSubtext, InfoP, InfoUL } from "pages/styles";
import { useEffect } from "react";
import { CenterFlexColumn } from "styles/layout";
import { AboutImage, PersonnelContainer, PersonnelWrapper } from "./styles";

export const AboutUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SingleColumnPage>
      <Panel padding="padded">
        <CenterFlexColumn>
          <AboutImage src={"/images/ecm/about.png"} />
        </CenterFlexColumn>
        <h2>About Us</h2>
        <InfoP>
          What started as a simple idea, building a site to make match
          predictions ahead of the Trackmania 2023 World Tour, eCiruitMania
          quickly evolved into something much bigger. There was no central place
          offering detailed stats and match histories with the depth we wanted.
          So, we built one. As the project gained traction, we grew by helping
          optimize broadcast features and enhancing the viewing experience. From
          there, we expanded our support to include all community tournaments,
          and we haven’t slowed down since. Today, we’re committed to
          continually improving our platform and bringing new features to the
          Trackmania competitive community.
        </InfoP>

        <InfoH3>Our Mission</InfoH3>
        <InfoP>
          To be the ultimate hub for competitive Trackmania by empowering
          players, fans, and organizers with innovative tools and resources.
        </InfoP>
        <InfoP>
          We strive to elevate every aspect of the competitive experience,
          providing players and fans with detailed stats and engaging pick’ems,
          while equipping organizers with advanced tournament management and
          broadcast tools. Through these efforts, we aim to grow the competitive
          Trackmania community and inspire a new standard of excellence in
          esports.
        </InfoP>

        <InfoH3>Key Features</InfoH3>
        <br />
        <InfoUL>
          <li>A centralized hub for TrackMania eSports.</li>
          <li>Pick'em predictions.</li>
          <li>Detailed player, track and tournament statistics.</li>
          <li>
            A user-friendly tool for tournament organizers to configure events
            directly on our website.
          </li>
          <li>Support of various tournament formats and match types.</li>
          <li>
            Integration plugins (OpenPlanet or ManiaControl) to automate the
            transfer of match data to our database.
          </li>
          <li>
            Future development plans for customizable overlay tools for live
            statistics during broadcasts.
          </li>
        </InfoUL>

        <PersonnelWrapper>
          <PersonnelContainer>
            <InfoH3>
              Unanimous
              <InfoHeaderSubtext> Co-Founder</InfoHeaderSubtext>
            </InfoH3>

            <InfoP>
              With a Master's degree in Mechanical Engineering and a background
              in the Aerospace industry, he brings a unique blend of technical
              expertise and creative vision to his work.
            </InfoP>

            <InfoP>
              Having started playing Trackmania in January 2022, Unanimous
              combines his passion for the game with a drive to create
              meaningful contributions for its players. Outside of work, he
              enjoys exploring the world of cinema as an avid movie enthusiast,
              drawing inspiration from diverse stories and genres.
            </InfoP>
          </PersonnelContainer>

          <PersonnelContainer>
            <InfoH3>
              Jacobs<InfoHeaderSubtext> Co-Founder</InfoHeaderSubtext>
            </InfoH3>

            <InfoP>
              Holding a Master's degree in Computer Science and multiple years
              experience as a software developer, he provides key technical
              experience to eCM.
            </InfoP>

            <InfoP>
              After having played some of the earlier titles, Jacobs resumed
              playing Trackmania in September 2021, renewing a love for the
              game. Despite playing casually he enjoys competiting for higher
              ranks, having competed in other games before. In addition he has a
              keen interest in geography, playing the piano and going for walks.
            </InfoP>
          </PersonnelContainer>

          <PersonnelContainer>
            <InfoH3>
              Nixotica <InfoHeaderSubtext> Developer</InfoHeaderSubtext>
            </InfoH3>
            <InfoP>
              A software engineer with experience across big tech and the
              defense industry, backed by a Bachelor's degree in Computer
              Science and Mathematics.
            </InfoP>
            <InfoP>
              He’s been part of the Trackmania community since 2007 and has
              competed actively since 2017, bringing the same dedication and
              strategic mindset from his professional life into the game. When
              not working, he enjoys a variety of outdoor activities including
              hiking, biking, climbing, and golfing.
            </InfoP>
          </PersonnelContainer>
        </PersonnelWrapper>
        <br />
        <hr />
        <h2>Contact</h2>
        <InfoP>
          Email - {CONTACT_EMAIL}
          <br />
          <a href={X_LINK}>X (formerly Twitter)</a>
          <br />
          <a href={DISCORD_LINK}>Discord</a>
        </InfoP>
      </Panel>
    </SingleColumnPage>
  );
};
